import React from "react";
import Bear from "./Icons/Bear";
import TBWA from "./Icons/TBWA";

import Link from "../routes/Home/components/Link";
import "./IconHeader.scss";

export default function IconHeader() {
  return (
    <div className="icon-header">
      <Link to="/">
        <TBWA />
      </Link>
      <Bear />
    </div>
  );
}
